<template>
  <router-link v-if="href.startsWith('/')" :to="href"><slot /></router-link>
  <a v-else-if="href" :href="href" :rel="href.startsWith('http') ? 'noopener noreferrer' : null"
    ><slot
  /></a>
</template>
<script>
import { safeLink } from '@/services/contentApi';
export default {
  name: 'ContentLink',
  props: { to: { default: '' } },
  computed: {
    href() {
      return safeLink(this.to);
    },
  },
};
</script>
